export default __webpack_public_path__ + "static/media/img777.bd3cf0cf.png";